<template>
  <div>
    <o-section :overlay="true">
      <o-select-input icon="location" label="Locatie" initial="gent">
        <option value="gent">Gent</option>
        <option value="antwerpen">Antwerpen</option>
        <option value="leuven">Leuven</option>
        <option value="brussel">Brussel</option>
      </o-select-input>
    </o-section>
    <o-section :overlay="true">
      <o-select-input
        icon="brands/cambio"
        label="Standplaats"
        initial="dampoort"
      >
        <option value="dampoort">Gent-Dampoort</option>
        <option value="schoolkaai">Schoolkaai</option>
        <option value="ajuinlei">Ajuinlei</option>
      </o-select-input>
    </o-section>
  </div>
</template>

<script>
export default {
  name: 'OEditLocationStand'
}
</script>
